

<div class="eda-chart">
    @if(!!update) {
        <canvas
            #edaChart=base-chart
            baseChart
            [data]="inject.chartData"
            [datasets]="inject.chartDataset"
            [labels]="inject.chartLabels"
            [type]="inject.chartType"
            [plugins]="chartPlugins"
            [options]="inject.chartOptions"
            [legend]="inject.chartLegend"
        >
        <!-- [colors]="inject.chartColors" -->
        </canvas>
    }
</div>





